import {
  SCHEDULE_INTERVIEW_REQUEST, SCHEDULE_INTERVIEW_FAIL, SCHEDULE_INTERVIEW_SUCCESS
} from "../constants/AuthConstant";

const initialState = {
  loading: false,
  action: "Home Action",
  result: [],
  msg: "",
  error: "",
};

const ScheduleInterviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case SCHEDULE_INTERVIEW_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case SCHEDULE_INTERVIEW_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case SCHEDULE_INTERVIEW_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default ScheduleInterviewReducer;
